import { createRoot } from 'react-dom/client'
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import PublicLayoutBuilderPage from './PublicLayoutBuilderPage'
import { prefetchLayoutCatalog } from '../src/components/layoutBuilder/layoutCatalogCache'
import { apiUrl } from './publicConfig'

// Starts the public catalog request before the first render.
prefetchLayoutCatalog(apiUrl)

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<PublicLayoutBuilderPage />)
